import { X } from 'lucide-react';

import { Button } from '@components/primitives/Button';

import { useNoticeContext } from './context';

import css from './styles.module.css';

export interface NoticeDismissProps {
  onClick: () => void;
  'aria-label'?: string;
}

export function NoticeDismiss({
  onClick,
  'aria-label': ariaLabel = 'Dismiss',
}: NoticeDismissProps) {
  const { variant } = useNoticeContext();

  return (
    <div className={css.dismiss}>
      <Button
        type="button"
        size="xs"
        ghost
        flush
        onClick={onClick}
        aria-label={ariaLabel}
        variant={variant === 'danger' ? 'danger' : 'secondary'}
      >
        <X aria-hidden />
      </Button>
    </div>
  );
}
